import PropTypes from 'prop-types';

import { Divider, Modal, Stack, Button, Card } from '@mantine/core';
import PublishResultItem from '../PublishResultItem/PublishResultItem';

export default function PublishResultsModal({ opened, close, publishResults }) {
  return (
    <Modal size="lg" opened={opened} onClose={close} title="Published Results">
      <Stack>
        <Card withBorder variant="outline-secondary">
          <Stack>
            {publishResults.map((result, index) => (
              <Stack key={result.seqId}>
                <PublishResultItem result={result} />
                {publishResults.length > index + 1 && <Divider variant="dotted" />}
              </Stack>
            ))}
          </Stack>
        </Card>
        <Button fullWidth onClick={close}>
          Done
        </Button>
      </Stack>
    </Modal>
  );
}

PublishResultsModal.propTypes = {
  close: PropTypes.func,
  opened: PropTypes.bool,
  publishResults: PropTypes.arrayOf(PropTypes.shape({})),
};
